{
  "api_url": "https://apistg.bisom.fr/",
  "sentry": {
    "dsn": "https://e4628cf9c8b341dc9001d62537f02c40@glitchtip.bisom.fr/7",
    "environment": "staging",
    "debug": false,
    "sample_rate": 0.0
  }
}
